import { Group, Modal, Pagination, Table } from "@mantine/core";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { deviceApis } from "../../../../../shared/apis/device/apis";
import { handleChangeLocaleTime } from "../../../../../shared/utils/time";
interface IPropsCompanyHistoryModal {
  opened: boolean;
  close: () => void;
  mac: string;
}
const tableHead = [
  "번호",
  "변경 일시",
  "변경자",
  "대상",
  "거래처 구분",
  "거래처명",
];
export default function CompanyHistoryModal(props: IPropsCompanyHistoryModal) {
  const { opened, close, mac } = props;
  const [page, setPage] = useState(1);
  const size = 10;

  const payload = {
    page,
    size,
    mac,
  };

  const { data: dispatchHistory } = useQuery(
    ["getDispatchHistory", page, mac],
    () => deviceApis.shipment.getDispatchHistory(payload),
    {
      select: (data) => data.data,
    }
  );

  return (
    <Modal opened={opened} onClose={close} title="변경 이력" centered size="xl">
      <Table>
        <Table.Thead>
          <Table.Tr>
            {tableHead.map((head) => (
              <Table.Th key={head}>{head}</Table.Th>
            ))}
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {dispatchHistory.data.length > 0 ? (
            dispatchHistory.data.map((item: any, index: number) => (
              <Table.Tr key={item.id}>
                <Table.Td>
                  {(dispatchHistory.totalCount ?? 0) -
                    ((page - 1) * size + index)}
                </Table.Td>
                <Table.Td>{handleChangeLocaleTime(item.regDt)}</Table.Td>
                <Table.Td>{item.modUserName}</Table.Td>
                <Table.Td>
                  {item.channel === "MFM"
                    ? "EP/TP"
                    : item.channel === "SCAUTR"
                    ? "기계 제조사"
                    : "실사용자"}
                </Table.Td>
                <Table.Td>
                  {item.changeDir === "FROM"
                    ? "출고 거래처(From)"
                    : "입고 거래처(To)"}
                </Table.Td>
                <Table.Td>
                  {item.changeDir === "FROM"
                    ? `(${item.fromCompanyId}) ${item.fromCompanyName}`
                    : `(${item.toCompanyId}) ${item.toCompanyName}`}
                </Table.Td>
              </Table.Tr>
            ))
          ) : (
            <Table.Tr>
              <Table.Td colSpan={5} align="center">
                데이터가 없습니다.
              </Table.Td>
            </Table.Tr>
          )}
        </Table.Tbody>
      </Table>
      <Group mt="lg" justify="center">
        <Pagination
          total={Math.ceil(dispatchHistory.totalCount / size)}
          value={page}
          onChange={setPage}
        />
      </Group>
    </Modal>
  );
}
